import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteRemindersFilter = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.remindersDeleteFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.remindersFilters]);
    },
  });
};
